import mw from "../../../assets/images/logo/mw.png";

export default function SelectContent() {
  return (
    <img
      src={mw}
      style={{
        objectFit: "cover",
        objectPosition: "left",
        width: "50px",
        height: "50px",
        clipPath: "circle(50% at 25px 25px)" // optional, for circular crop
      }}
      alt=""
    />
  );
}
